module.exports = __webpack_public_path__ + "img/credit.3062bbaa.png";